module.exports = __webpack_public_path__ + "static/UNITY-Tower-upper-floor-4-tenants_v2-d684f6ef8af9c21c28f6108a1bd62d3c.pdf";